export const name_validation_ro = {
  name: "name",
  label: "name",
  type: "text",
  id: "name",
  placeholder: "Numele tău",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: true,
      message: "obligatoriu",
    },
    maxLength: {
      value: 30,
      message: "maximum 30 caractere",
    },
  },
};

export const from_hidden_validation_ro = {
  name: "form",
  label: "form",
  type: "hidden",
  id: "form",
  placeholder: "",
  className: "",
  value: "Footer Form",
  validation: {
    required: {
      value: true,
      message: "obligatoriu",
    },
  },
};

export const to_hidden_validation_ro = {
  name: "to",
  label: "to",
  type: "hidden",
  id: "to",
  placeholder: "",
  className: "",
  value: "web@twid.marketing",
  validation: {
    required: {
      value: true,
      message: "obligatoriu",
    },
  },
};

export const company_validation_ro = {
  name: "company",
  label: "company",
  type: "text",
  id: "company",
  placeholder: "Companie",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: false,
      message: "obligatoriu",
    },
    maxLength: {
      value: 30,
      message: "maximum 30 caractere",
    },
  },
};

export const message_validation_ro = {
  name: "message",
  label: "message",
  type: "textarea",
  multiline: true,
  id: "message",
  placeholder: "Mesaj",
  className: "",
  validation: {
    required: {
      value: true,
      message: "obligatoriu",
    },
    maxLength: {
      value: 200,
      message: "maximum 200 caractere",
    },
  },
};

export const password_validation_ro = {
  name: "password",
  label: "password",
  type: "password",
  id: "password",
  placeholder: "type password ...",
  validation: {
    required: {
      value: true,
      message: "obligatoriu",
    },
    minLength: {
      value: 6,
      message: "min 6 characters",
    },
  },
};

export const num_validation_ro = {
  name: "num",
  label: "number",
  type: "number",
  id: "num",
  placeholder: "write a random number",
  validation: {
    required: {
      value: true,
      message: "obligatoriu",
    },
  },
};

export const email_validation_ro = {
  name: "email",
  label: "email address",
  type: "email",
  id: "email",
  placeholder: "E-mail",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: true,
      message: "obligatoriu",
    },
    pattern: {
      value:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: "invalid",
    },
  },
};
